import { UsageData } from '@paragon/contract-library';

import { DesignService } from '../connections';

export function getTrussDesignUsage(): Promise<UsageData> {
  return DesignService.get('public/usageData/trussDesigns');
}
